import * as React from 'react';
import { KeyboardShortcutTooltip } from '../../../misc/components/KeyboardShortcutTooltip';
import * as classNames from 'classnames';
import { OnIgnoreEnter } from '../AnalyseApp';

interface GridlineToggleProps {
    isVisible: boolean;
    isKeyboardShortcutVisible: boolean;
    onClick: () => void;
}

export const GridlineToggle = (props: GridlineToggleProps) => {
    const gridLinesClasses = classNames(
        'fas',
        'fa-fw',
        {
            'fa-toggle-on': props.isVisible,
            'fa-toggle-off': !props.isVisible
        }
    );

    return (
        <button id="ToggleGridline" className="btn btn-primary" style={{ minWidth: 90 + 'px' }} onClick={(e: any) => { e.target.blur(); props.onClick(); }} onKeyDown={OnIgnoreEnter}>
            <i className={gridLinesClasses} aria-hidden="true"></i>&nbsp;
            Gridline
            &nbsp;
            <KeyboardShortcutTooltip show={props.isKeyboardShortcutVisible} keyName="G" />
        </button>
    );
}
